import { AnyAction } from 'redux';
import * as accountFundingActions from 'stash/actions/accountFunding';
import type { AccountFundingState } from 'stash/components/account-funding/types';

const accountFundingReducer = (
	state: AccountFundingState = {},
	action: AnyAction
): AccountFundingState => {
	switch (action.type) {
		case accountFundingActions.SET_ACCOUNT_FUNDING_STATE:
			return { ...state, ...action.payload };
		case accountFundingActions.CLEAR_ACCOUNT_FUNDING_STATE:
			return {};
		default:
			return state;
	}
};

export default accountFundingReducer;
